import { Component } from '@angular/core';

@Component({
  selector: 'invoice-management',
  templateUrl: './invoice-management.component.html',
  styles: [
    `
      .no-margin {
        margin: 0;
        padding-bottom: 2rem;
      }
    `,
  ],
  standalone: false,
})
export class InvoiceManagement {}
